import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { GrupoExibicaoProps } from 'pages/cadastro/loja/types';

export function useQueryGrupoExibicao() {
    const { page, filter } = useListagemContext();

    const requestListagem = useRequestListagem();

    const requestGrupoExibicaoOptions: RequestOptionsType = {
        url: 'gestao/configuracaopropriedadegrupoexibicao',
        sort: [{ property: 'nrSequencia', direction: 'ASC' }],
        filter,
        page,
        limit: 30,
    };

    return useQuery<RequestListagem<GrupoExibicaoProps[]>>([requestGrupoExibicaoOptions], () =>
        requestListagem(requestGrupoExibicaoOptions).then((res) => res.data),
    );
}
